import Transformer from '@/transformers/transformer'

import moment from 'moment'
moment.locale('es-mx');

export default class supplyConfigTransformer extends Transformer {
  static fetch() {
    return {}
  }

  static send(data) {
    return {
      supply_id: data.supplyId,
      iwarehouse_quantification_supply_ids: data.quantificationSupplyIds,
      sum_quantity_to_requested: data.quantityToRequest
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/warehouse/requisitionSM.js